import React from 'react';
import PropTypes from 'prop-types';

import Thumbnail from '@components/shared/Thumbnail';

const ProductThumbnail = ({ src, ...rest }) => {
  let propsSource = src;

  if (!propsSource) {
    propsSource = '/images/default-product.svg';
  }
  return <Thumbnail src={propsSource} {...rest} />;
};

ProductThumbnail.propTypes = {
  src: PropTypes.any
};

export default ProductThumbnail;
